/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CustomColumnTypeFromJSON, CustomColumnTypeToJSON } from './';
export function CustomColumnRepresentationFromJSON(json) {
    return CustomColumnRepresentationFromJSONTyped(json, false);
}
export function CustomColumnRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        type: !exists(json, 'type') ? undefined : CustomColumnTypeFromJSON(json['type']),
        name: json['name'],
        readonly: json['readonly'],
        width: json['width'],
        accountTagId: !exists(json, 'accountTagId') ? undefined : json['accountTagId'],
        dimensionTagIds: !exists(json, 'dimensionTagIds') ? undefined : json['dimensionTagIds'],
        tableTagId: !exists(json, 'tableTagId') ? undefined : json['tableTagId'],
        property: !exists(json, 'property') ? undefined : json['property'],
    };
}
export function CustomColumnRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        type: CustomColumnTypeToJSON(value.type),
        name: value.name,
        readonly: value.readonly,
        width: value.width,
        accountTagId: value.accountTagId,
        dimensionTagIds: value.dimensionTagIds,
        tableTagId: value.tableTagId,
        property: value.property,
    };
}
